import React, { useState } from "react";
import { Button, Modal } from "antd";
import { toast } from "react-toastify";
import { nonNumericRegex } from "../../hooks/helper";
import Select from "react-select";
import { storeTestimonials, updateTestimonials } from "../../Libs/api";
import Loader from "../../Component/Loader";
const EditTestimonials = ({ singleData, openModal, onClose, onSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({
    name: singleData?.name,
    rating: { label: singleData?.rating, value: singleData?.rating },
    designation: singleData?.designation,
    companyName: singleData?.companyName,
    review: singleData?.review,
    status: singleData?.status
      ? { label: "Active", value: true }
      : { label: "Inactive", value: false },
  });

  const [inputDataError, setInputDataError] = useState({
    name: false,
    rating: false,
    designation: false,
    companyName: false,
    review: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputData?.name) {
      toast.error("Please enter a name for the testimonials");
      setInputDataError({ ...inputDataError, name: true });
    } else if (inputData.name.length < 3) {
      toast.error("Name must contain at least 3 characters");
      setInputDataError({ ...inputDataError, name: true });
    } else if (!inputData?.companyName) {
      toast.error("Please enter a company name for the testimonials");
      setInputDataError({ ...inputDataError, companyName: true });
    } else if (inputData.companyName.length < 3) {
      toast.error("Company name must contain at least 3 characters");
      setInputDataError({ ...inputDataError, companyName: true });
    } else if (!inputData?.designation) {
      toast.error("Please enter a designation for the testimonials");
      setInputDataError({ ...inputDataError, designation: true });
    } else if (inputData.designation.length < 2) {
      toast.error("Designation must contain at least 2 characters");
      setInputDataError({ ...inputDataError, designation: true });
    } else if (!inputData?.rating) {
      toast.error("Please enter a rating for the testimonials");
      setInputDataError({ ...inputDataError, rating: true });
    } else if (!inputData?.review) {
      toast.error("Please enter a review for the testimonials");
      setInputDataError({ ...inputDataError, review: true });
    } else if (inputData.review.length < 3) {
      toast.error("Review must contain at least 3 characters");
      setInputDataError({ ...inputDataError, review: true });
    } else {
      setLoading(true);

      let formData = {
        name: inputData?.name,
        rating: inputData?.rating?.value,
        designation: inputData?.designation,
        companyName: inputData?.companyName,
        review: inputData?.review,
        status: inputData?.status?.value,
      };

      try {
        const apiCall = await updateTestimonials(formData, singleData?.id);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");

          setLoading(false);
          toast.success("Record Updated Successfully!");
          onSubmit();
        } else {
          setLoading(false);

          toast.error(apiCall?.message);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error(error);
      }
    }
  };

  return (
    <Modal
      title={
        <div
          style={{
            background: "#006666",
            color: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          Edit Testimonials
        </div>
      }
      centered
      open={openModal}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={[
        <Button
          key="ok"
          type="primary"
          style={{ background: "#006666", color: "white" }}
          disabled={loading}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          Update Testimonials
        </Button>,
      ]}
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center mt-3 mb-3">
                <svg className="custom-loader" viewBox="25 25 50 50">
                  <circle
                    className="custom-loader-circle"
                    r="20"
                    cy="50"
                    cx="50"
                  ></circle>
                </svg>
              </div>
            ) : (
              <div class="row mt-3">
                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Name</label>
                    <input
                      class={`form-control ${
                        inputDataError?.name ? "border-danger" : ""
                      }`}
                      type="text"
                      placeholder="Enter Name.."
                      value={inputData?.name}
                      onChange={(e) => {
                        if (
                          nonNumericRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setInputData({
                            ...inputData,
                            name: e.target.value,
                          });

                          if (e.target.value?.length >= 3) {
                            setInputDataError({
                              ...inputDataError,
                              name: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              name: true,
                            });
                          }
                        } else {
                          toast.error("Type Characters Only", {
                            toastId: "sysmbol",
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Company Name</label>
                    <input
                      class={`form-control ${
                        inputDataError?.companyName ? "border-danger" : ""
                      }`}
                      type="text"
                      placeholder="Enter Company Name.."
                      value={inputData?.companyName}
                      onChange={(e) => {
                        if (
                          nonNumericRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setInputData({
                            ...inputData,
                            companyName: e.target.value,
                          });

                          if (e.target.value?.length >= 3) {
                            setInputDataError({
                              ...inputDataError,
                              companyName: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              companyName: true,
                            });
                          }
                        } else {
                          toast.error("Type Characters Only", {
                            toastId: "sysmbol",
                          });
                        }
                      }}
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Designation</label>
                    <input
                      class={`form-control ${
                        inputDataError?.designation ? "border-danger" : ""
                      }`}
                      type="text"
                      placeholder="Enter Designation.."
                      value={inputData?.designation}
                      onChange={(e) => {
                        if (
                          nonNumericRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setInputData({
                            ...inputData,
                            designation: e.target.value,
                          });

                          if (e.target.value?.length >= 2) {
                            setInputDataError({
                              ...inputDataError,
                              designation: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              designation: true,
                            });
                          }
                        } else {
                          toast.error("Type Characters Only", {
                            toastId: "sysmbol",
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Rating</label>
                    <Select
                      className={`${
                        inputDataError?.rating ? "border border-danger" : ""
                      }`}
                      value={inputData?.rating}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          rating: e,
                        });

                        setInputDataError({
                          ...inputDataError,
                          rating: false,
                        });
                      }}
                      options={[
                        { label: "1", value: 1 },
                        { label: "2", value: 2 },
                        { label: "3", value: 3 },
                        { label: "4", value: 4 },
                        { label: "5", value: 5 },
                      ]}
                    ></Select>
                  </div>
                </div>

                <div class="col-sm-12 col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Review</label>
                    <textarea
                      class={`form-control ${
                        inputDataError?.review ? "border-danger" : ""
                      }`}
                      type="textarea"
                      placeholder="Enter Review.."
                      value={inputData?.review}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          review: e.target.value,
                        });

                        if (e.target.value?.length >= 3) {
                          setInputDataError({
                            ...inputDataError,
                            review: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            review: true,
                          });
                        }
                      }}
                    />
                  </div>
                </div>

                <div class="col-sm-4 col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Status</label>
                    <Select
                      value={inputData?.status}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          status: e,
                        });
                      }}
                      class={`form-control btn-square ${
                        inputDataError?.status ? "border-danger" : ""
                      }`}
                      options={[
                        { value: true, label: "Active" },
                        { value: false, label: "Inactive" },
                      ]}
                    ></Select>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditTestimonials;
